import { render, staticRenderFns } from "./addPass.vue?vue&type=template&id=39f870ac&scoped=true&"
import script from "./addPass.vue?vue&type=script&lang=js&"
export * from "./addPass.vue?vue&type=script&lang=js&"
import style0 from "./addPass.vue?vue&type=style&index=0&id=39f870ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f870ac",
  null
  
)

export default component.exports